import { useCallback } from 'react';
import { useAppSelector } from '../hooks';
import { localLogOut } from '../Functions';
import { logoutRequest } from '../requests/session.request';
import { AuthScope } from '../types/auth.types';

/** In-house auth state (replaces useAuth0). */
export function useAuth() {
  const accessToken = useAppSelector((state) => state.config.accessToken);
  const user = useAppSelector((state) => state.config.authUser);

  const isAuthenticated = Boolean(accessToken && user);

  const hasScope = useCallback(
    (scope: AuthScope) => Boolean(user?.scopes?.includes(scope)),
    [user]
  );

  const logout = useCallback(async () => {
    await logoutRequest();
    localLogOut();
    window.location.assign('/login');
  }, []);

  return { isAuthenticated, isLoading: false, user, hasScope, logout };
}
